import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../../environments/environment';
import { IFatura } from './../../../../../interfaces/ifatura';
import { IFaturaDetalhada } from '../../../../../interfaces/ifatura-detalhada';
import { Convert } from './../../../../../utils/convert';
import { Fatura } from './../../../../../utils/fatura';

@Component({
  selector: 'eae-fatura-escolha-pagamento',
  templateUrl: './eae-fatura-escolha-pagamento.component.html',
  styleUrls: [],
})
export class EaeFaturaEscolhaPagamentoComponent implements OnInit {
  copied: boolean = false;
  timeElapsed: number = 3000;
  diasMaximoAtraso: number = environment.diasMaximoAtraso;
  @Input()
  fatura!: IFatura;
  @Input()
  faturaDetalhada!: IFaturaDetalhada;
  convert: Convert = new Convert();

  showEscolhaPagamento: boolean = false

  @Input()
  showTicket: boolean = true;

  tipoPagamento: string = '';

  constructor() {}

  ngOnInit(): void {}

  public isOverDue(datefatura: string): boolean {
    return Fatura.isOverDue(datefatura);
  }

  public isDateOverDueMoreThanAnyDays(dateFatura: string, days: number): boolean {
    return Fatura.isDateOverDueMoreThanAnyDays(dateFatura, days);
  }

  public dateStringToBrazil(datefatura: string): string {
    return Convert.dateStringToBrazil(datefatura);
  }

  public formatCurrencyBrazil(value: string) {
    return Convert.formatCurrencyBrazil(value);
  }

  public setShowEscolhaPagamento(value: boolean) {
    this.showEscolhaPagamento = value;
  }

}
